// Mock data for Sales & Renewals component
export const opportunities = [
  {
    id: 'OPP-2024-001',
    name: 'AutoCAD Enterprise Deployment',
    customer: 'TechCorp Solutions',
    contactPerson: 'John Smith',
    email: 'john.smith@techcorp.com',
    value: 'R125,000',
    product: 'AutoCAD Licenses',
    stage: '04-Proposal',
    closeDate: '2024-08-15',
    createdDate: '2024-06-10',
    lastActivity: '2024-07-15',
    description: '50-seat AutoCAD deployment with training and support',
    notes: 'Customer is evaluating against competitors. Price is competitive.',
    salesStatus: null,
    autodeskEvent: 'Initial order',
    createdBy: 'Sarah Williams',
    productLines: [
      {
        id: '1',
        product: 'AutoCAD Commercial',
        description: 'AutoCAD Commercial Single-User License',
        quantity: 50,
        unitPrice: 2500,
        discount: 0,
        total: 125000
      }
    ]
  },
  {
    id: 'OPP-2024-002',
    name: 'Revit Architecture Upgrade',
    customer: 'Design Studios Inc',
    contactPerson: 'Sarah Johnson',
    email: 'sarah@designstudios.com',
    value: 'R85,000',
    product: 'Revit Licenses',
    stage: '02-Qualification',
    closeDate: '2024-09-30',
    createdDate: '2024-07-01',
    lastActivity: '2024-07-20',
    description: 'Upgrade from AutoCAD to Revit for architectural team',
    notes: 'Need to schedule technical demo.',
    salesStatus: null,
    autodeskEvent: 'Addition',
    createdBy: 'Michael Roberts',
    productLines: [
      {
        id: '1',
        product: 'Revit Architecture',
        description: 'Revit Architecture Single-User License',
        quantity: 25,
        unitPrice: 3400,
        discount: 0,
        total: 85000
      }
    ]
  },
  {
    id: 'OPP-2024-003',
    name: 'Civil 3D Implementation',
    customer: 'Infrastructure Partners LLC',
    contactPerson: 'Michael Chen',
    email: 'michael.chen@infra-partners.com',
    value: 'R215,000',
    product: 'Civil 3D Licenses',
    stage: '06-Closed Won',
    closeDate: '2024-06-15',
    createdDate: '2024-05-01',
    lastActivity: '2024-10-01',
    description: 'Complete Civil 3D deployment for infrastructure projects',
    notes: 'Order placed and awaiting delivery.',
    salesStatus: 'Open order',
    autodeskEvent: 'Initial order',
    createdBy: 'Sarah Williams',
    productLines: [
      {
        id: '1',
        product: 'Civil 3D',
        description: 'Civil 3D Single-User License',
        quantity: 35,
        unitPrice: 6142,
        discount: 0,
        total: 215000
      }
    ]
  },
  {
    id: 'OPP-2024-004',
    name: 'AEC Collection Renewal',
    customer: 'BuildRight Construction',
    contactPerson: 'Amanda Foster',
    email: 'amanda@buildright.com',
    value: 'R95,000',
    product: 'AEC Collection',
    stage: '06-Closed Won',
    closeDate: '2024-05-20',
    createdDate: '2024-04-10',
    lastActivity: '2024-09-28',
    description: 'Annual renewal for AEC Collection licenses',
    notes: 'Licenses delivered to customer.',
    salesStatus: 'Delivered',
    autodeskEvent: 'None',
    createdBy: 'John Anderson',
    productLines: [
      {
        id: '1',
        product: 'AEC Collection',
        description: 'AEC Collection Single-User License',
        quantity: 15,
        unitPrice: 6333,
        discount: 0,
        total: 95000
      }
    ]
  },
  {
    id: 'OPP-2024-005',
    name: 'Maya Animation Suite',
    customer: 'Creative Studios Pro',
    contactPerson: 'David Lee',
    email: 'david@creativestudios.com',
    value: 'R178,000',
    product: 'Maya Licenses',
    stage: '06-Closed Won',
    closeDate: '2024-04-30',
    createdDate: '2024-03-15',
    lastActivity: '2024-09-15',
    description: 'Maya licenses for animation department',
    notes: 'Fully invoiced and payment received.',
    salesStatus: 'Invoiced',
    autodeskEvent: 'Initial order',
    createdBy: 'Michael Roberts',
    productLines: [
      {
        id: '1',
        product: 'Maya',
        description: 'Maya Single-User License',
        quantity: 20,
        unitPrice: 8900,
        discount: 0,
        total: 178000
      }
    ]
  }
];

export const endUsersWithContacts = [
  {
    id: "eu001",
    name: "TechCorp Solutions",
    contactPerson: "John Smith",
    email: "john.smith@techcorp.com",
    phone: "+27 (11) 555-0001",
    address: "15 Sandton Drive, Sandton City",
    city: "Johannesburg",
    state: "Gauteng",
    postalCode: "2196",
    country: "South Africa",
    location: "15 Sandton Drive, Sandton City, Johannesburg, Gauteng 2196, South Africa",
    industry: "Technology",
    licenses: 50,
    status: "Active",
    csn: "CSN-2024-001-TCS",
    contacts: [
      {
        id: "contact-001-1",
        name: "John Smith",
        email: "john.smith@techcorp.com",
        phone: "+27 (11) 555-0001",
        role: "IT Director",
        isPrimary: true
      },
      {
        id: "contact-001-2",
        name: "Emily Watson",
        email: "emily.watson@techcorp.com",
        phone: "+27 (11) 555-0002",
        role: "Procurement Manager",
        isPrimary: false
      },
      {
        id: "contact-001-3",
        name: "Robert Johnson",
        email: "robert.johnson@techcorp.com",
        phone: "+27 (11) 555-0003",
        role: "CAD Administrator",
        isPrimary: false
      }
    ]
  },
  {
    id: "eu002",
    name: "Design Studios Inc",
    contactPerson: "Sarah Johnson",
    email: "sarah@designstudios.com",
    phone: "+27 (21) 555-0010",
    address: "42 Bree Street, Cape Town CBD",
    city: "Cape Town",
    state: "Western Cape",
    postalCode: "8001",
    country: "South Africa",
    location: "42 Bree Street, Cape Town CBD, Cape Town, Western Cape 8001, South Africa",
    industry: "Architecture",
    licenses: 25,
    status: "Active",
    csn: "CSN-2024-002-DSI",
    contacts: [
      {
        id: "contact-002-1",
        name: "Sarah Johnson",
        email: "sarah@designstudios.com",
        phone: "+27 (21) 555-0010",
        role: "Principal Architect",
        isPrimary: true
      },
      {
        id: "contact-002-2",
        name: "Michael Brown",
        email: "michael.brown@designstudios.com",
        phone: "+27 (21) 555-0011",
        role: "Design Manager",
        isPrimary: false
      },
      {
        id: "contact-002-3",
        name: "Jennifer Lee",
        email: "jennifer.lee@designstudios.com",
        phone: "+27 (21) 555-0012",
        role: "Office Manager",
        isPrimary: false
      }
    ]
  },
  {
    id: "eu003",
    name: "Infrastructure Partners LLC",
    contactPerson: "Michael Chen",
    email: "michael.chen@infra-partners.com",
    phone: "+27 (31) 555-0020",
    address: "88 Durban Point Waterfront",
    city: "Durban",
    state: "KwaZulu-Natal",
    postalCode: "4001",
    country: "South Africa",
    location: "88 Durban Point Waterfront, Durban, KwaZulu-Natal 4001, South Africa",
    industry: "Civil Engineering",
    licenses: 35,
    status: "Active",
    csn: "CSN-2024-003-IPL",
    contacts: [
      {
        id: "contact-003-1",
        name: "Michael Chen",
        email: "michael.chen@infra-partners.com",
        phone: "+27 (31) 555-0020",
        role: "Engineering Director",
        isPrimary: true
      },
      {
        id: "contact-003-2",
        name: "Patricia Williams",
        email: "patricia.williams@infra-partners.com",
        phone: "+27 (31) 555-0021",
        role: "Project Coordinator",
        isPrimary: false
      },
      {
        id: "contact-003-3",
        name: "James Davis",
        email: "james.davis@infra-partners.com",
        phone: "+27 (31) 555-0022",
        role: "Technical Lead",
        isPrimary: false
      },
      {
        id: "contact-003-4",
        name: "Angela Martinez",
        email: "angela.martinez@infra-partners.com",
        phone: "+27 (31) 555-0023",
        role: "Finance Manager",
        isPrimary: false
      }
    ]
  },
  {
    id: "eu004",
    name: "BuildRight Construction",
    contactPerson: "Amanda Foster",
    email: "amanda@buildright.com",
    phone: "+27 (41) 555-0030",
    address: "125 Main Road, Newton Park",
    city: "Port Elizabeth",
    state: "Eastern Cape",
    postalCode: "6045",
    country: "South Africa",
    location: "125 Main Road, Newton Park, Port Elizabeth, Eastern Cape 6045, South Africa",
    industry: "Construction",
    licenses: 15,
    status: "Active",
    csn: "CSN-2024-004-BRC",
    contacts: [
      {
        id: "contact-004-1",
        name: "Amanda Foster",
        email: "amanda@buildright.com",
        phone: "+27 (41) 555-0030",
        role: "Operations Manager",
        isPrimary: true
      },
      {
        id: "contact-004-2",
        name: "Thomas Anderson",
        email: "thomas.anderson@buildright.com",
        phone: "+27 (41) 555-0031",
        role: "Site Manager",
        isPrimary: false
      },
      {
        id: "contact-004-3",
        name: "Rebecca Taylor",
        email: "rebecca.taylor@buildright.com",
        phone: "+27 (41) 555-0032",
        role: "Purchasing Officer",
        isPrimary: false
      }
    ]
  },
  {
    id: "eu005",
    name: "Creative Studios Pro",
    contactPerson: "David Lee",
    email: "david@creativestudios.com",
    phone: "+27 (11) 555-0040",
    address: "210 Katherine Street, Sandton Square",
    city: "Sandton",
    state: "Gauteng",
    postalCode: "2146",
    country: "South Africa",
    location: "210 Katherine Street, Sandton Square, Sandton, Gauteng 2146, South Africa",
    industry: "Media & Entertainment",
    licenses: 20,
    status: "Active",
    csn: "CSN-2024-005-CSP",
    contacts: [
      {
        id: "contact-005-1",
        name: "David Lee",
        email: "david@creativestudios.com",
        phone: "+27 (11) 555-0040",
        role: "Creative Director",
        isPrimary: true
      },
      {
        id: "contact-005-2",
        name: "Sophie Miller",
        email: "sophie.miller@creativestudios.com",
        phone: "+27 (11) 555-0041",
        role: "Animation Lead",
        isPrimary: false
      },
      {
        id: "contact-005-3",
        name: "Christopher Wilson",
        email: "chris.wilson@creativestudios.com",
        phone: "+27 (11) 555-0042",
        role: "Technical Director",
        isPrimary: false
      },
      {
        id: "contact-005-4",
        name: "Natalie Roberts",
        email: "natalie.roberts@creativestudios.com",
        phone: "+27 (11) 555-0043",
        role: "Studio Manager",
        isPrimary: false
      }
    ]
  },
  {
    id: "eu006",
    name: "ABC Engineering Solutions",
    contactPerson: "Sarah Mitchell",
    email: "sarah.mitchell@abceng.com",
    phone: "+1 (555) 123-4567",
    address: "1234 Pike Street, Suite 500",
    city: "Seattle",
    state: "WA",
    postalCode: "98101",
    country: "USA",
    location: "1234 Pike Street, Suite 500, Seattle, WA 98101, USA",
    industry: "Civil Engineering",
    licenses: 25,
    status: "Active",
    csn: "CSN-2024-006-ABC",
    contacts: [
      {
        id: "contact-006-1",
        name: "Sarah Mitchell",
        email: "sarah.mitchell@abceng.com",
        phone: "+1 (555) 123-4567",
        role: "Primary Contact",
        isPrimary: true
      },
      {
        id: "contact-006-2",
        name: "John Mitchell",
        email: "john.mitchell@abceng.com",
        phone: "+1 (555) 123-4568",
        role: "Technical Lead",
        isPrimary: false
      },
      {
        id: "contact-006-3",
        name: "Lisa Chen",
        email: "lisa.chen@abceng.com",
        phone: "+1 (555) 123-4569",
        role: "Finance Manager",
        isPrimary: false
      }
    ]
  },
  {
    id: "eu007",
    name: "Precision Architecture Group",
    contactPerson: "David Chen",
    email: "david.chen@precision-arch.com",
    phone: "+1 (555) 234-5678",
    address: "567 SW Morrison Street, Floor 12",
    city: "Portland",
    state: "OR",
    postalCode: "97204",
    country: "USA",
    location: "567 SW Morrison Street, Floor 12, Portland, OR 97204, USA",
    industry: "Architecture",
    licenses: 15,
    status: "Active",
    csn: "CSN-2024-007-PAG",
    contacts: [
      {
        id: "contact-007-1",
        name: "David Chen",
        email: "david.chen@precision-arch.com",
        phone: "+1 (555) 234-5678",
        role: "Principal Architect",
        isPrimary: true
      },
      {
        id: "contact-007-2",
        name: "Maria Santos",
        email: "maria.santos@precision-arch.com",
        phone: "+1 (555) 234-5679",
        role: "Project Manager",
        isPrimary: false
      }
    ]
  },
  {
    id: "eu008",
    name: "Metro Construction Group",
    contactPerson: "Lisa Rodriguez",
    email: "lisa.rodriguez@metroconstruction.com",
    phone: "+1 (555) 345-6789",
    address: "890 16th Street Mall, Building C",
    city: "Denver",
    state: "CO",
    postalCode: "80202",
    country: "USA",
    location: "890 16th Street Mall, Building C, Denver, CO 80202, USA",
    industry: "Construction",
    licenses: 40,
    status: "Pending Renewal",
    csn: "CSN-2024-008-MCG",
    contacts: [
      {
        id: "contact-008-1",
        name: "Lisa Rodriguez",
        email: "lisa.rodriguez@metroconstruction.com",
        phone: "+1 (555) 345-6789",
        role: "Operations Director",
        isPrimary: true
      },
      {
        id: "contact-008-2",
        name: "Carlos Martinez",
        email: "carlos.martinez@metroconstruction.com",
        phone: "+1 (555) 345-6790",
        role: "IT Manager",
        isPrimary: false
      },
      {
        id: "contact-008-3",
        name: "Jennifer Adams",
        email: "jennifer.adams@metroconstruction.com",
        phone: "+1 (555) 345-6791",
        role: "Purchasing Manager",
        isPrimary: false
      }
    ]
  }
];

export const endUsers = [
  {
    id: '1',
    name: 'North Valley Farms LLC',
    contactPerson: 'John Peterson',
    email: 'j.peterson@nvfarms.com',
    phone: '+1 (555) 123-4567',
    address: '123 Farm Road',
    city: 'Springfield',
    state: 'IL',
    postalCode: '62701',
    country: 'USA',
    location: '123 Farm Road, Springfield, IL 62701, USA',
    industry: 'Agriculture',
    licenses: 25,
    licenseCount: '25',
    status: 'Active',
    csn: 'CSN-2024-009-NVF'
  },
  {
    id: '2',
    name: 'Green Acres Agricultural Co.',
    contactPerson: 'Maria Rodriguez',
    email: 'm.rodriguez@greenacres.com',
    phone: '+1 (555) 234-5678',
    address: '456 Green Valley Drive',
    city: 'Riverside',
    state: 'CA',
    postalCode: '92501',
    country: 'USA',
    location: '456 Green Valley Drive, Riverside, CA 92501, USA',
    industry: 'Agriculture',
    licenses: 15,
    licenseCount: '15',
    status: 'Active',
    csn: 'CSN-2024-010-GAC'
  },
  {
    id: '3',
    name: 'Sunrise Organics Inc.',
    contactPerson: 'David Kim',
    email: 'd.kim@sunriseorganics.com',
    phone: '+1 (555) 345-6789',
    address: '789 Sunrise Boulevard',
    city: 'Portland',
    state: 'OR',
    postalCode: '97204',
    country: 'USA',
    location: '789 Sunrise Boulevard, Portland, OR 97204, USA',
    industry: 'Organic Farming',
    licenses: 8,
    licenseCount: '8',
    status: 'Active',
    csn: 'CSN-2024-011-SOI'
  }
];

export const priceList = [
  {
    id: '1',
    sku: 'C0R01-651151-A392',
    description: 'AutoCAD Commercial Single-User Annual Subscription Renewal',
    contractTerm: 'Annual',
    itemGroup: 'AutoCAD',
    unitPrice: 1387.00,
    businessSegment: 'AEC',
    productLineDescription: 'Industry-leading design and documentation software',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '2',
    sku: 'C0R41-402251-A392',
    description: 'Architecture, Engineering & Construction Collection Commercial Single-User Annual Subscription Renewal',
    contractTerm: 'Annual',
    itemGroup: 'AEC Collection',
    unitPrice: 3179.00,
    businessSegment: 'AEC',
    productLineDescription: 'Comprehensive collection for architecture, engineering and construction',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '3',
    sku: 'C1R41-WW2859-5392',
    description: 'Revit Commercial Single-User Annual Subscription Renewal',
    contractTerm: 'Annual',
    itemGroup: 'Revit',
    unitPrice: 4072.00,
    businessSegment: 'AEC',
    productLineDescription: 'Building information modeling software',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '4',
    sku: 'C2R01-652251-A392',
    description: 'Inventor Professional Commercial Single-User Annual Subscription Renewal',
    contractTerm: 'Annual',
    itemGroup: 'Inventor',
    unitPrice: 3421.00,
    businessSegment: 'Manufacturing',
    productLineDescription: '3D CAD software for product design and engineering',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '5',
    sku: 'C3R01-653251-A392',
    description: 'Maya Commercial Single-User Annual Subscription Renewal',
    contractTerm: 'Annual',
    itemGroup: 'Maya',
    unitPrice: 2873.00,
    businessSegment: 'Media & Entertainment',
    productLineDescription: '3D animation, modeling, simulation, and rendering software',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '6',
    sku: 'C4R01-654251-A392',
    description: '3ds Max Commercial Single-User Annual Subscription Renewal',
    contractTerm: 'Annual',
    itemGroup: '3ds Max',
    unitPrice: 2873.00,
    businessSegment: 'Media & Entertainment',
    productLineDescription: '3D modeling, animation, and rendering software',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '7',
    sku: 'C5R01-655251-A392',
    description: 'Fusion 360 Commercial Single-User Annual Subscription Renewal',
    contractTerm: 'Annual',
    itemGroup: 'Fusion 360',
    unitPrice: 1892.00,
    businessSegment: 'Manufacturing',
    productLineDescription: 'Cloud-based 3D CAD, CAM, CAE, and PCB design platform',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '8',
    sku: 'C6R01-656251-T392',
    description: 'AutoCAD LT Commercial Single-User Annual Subscription Renewal',
    contractTerm: 'Annual',
    itemGroup: 'AutoCAD LT',
    unitPrice: 895.00,
    businessSegment: 'AEC',
    productLineDescription: '2D drafting and documentation software',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '9',
    sku: 'C7R01-657251-M392',
    description: 'Civil 3D Commercial Single-User Monthly Subscription Renewal',
    contractTerm: 'Monthly',
    itemGroup: 'Civil 3D',
    unitPrice: 412.00,
    businessSegment: 'AEC',
    productLineDescription: 'Civil engineering design and documentation software',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '10',
    sku: 'C8R01-658251-T392',
    description: 'Plant 3D Commercial Single-User Triennial Subscription Renewal',
    contractTerm: 'Triennial',
    itemGroup: 'Plant 3D',
    unitPrice: 11250.00,
    businessSegment: 'Manufacturing',
    productLineDescription: 'Plant design and engineering software',
    seatTypeId: 'Subscription Renewal',
    skuTypeId: 'Subscription Renewal'
  },
  {
    id: '11',
    sku: 'N0N01-651151-A392',
    description: 'AutoCAD Commercial Single-User Annual Subscription New',
    contractTerm: 'Annual',
    itemGroup: 'AutoCAD',
    unitPrice: 2154.00,
    businessSegment: 'AEC',
    productLineDescription: 'Industry-leading design and documentation software',
    seatTypeId: 'Subscription New',
    skuTypeId: 'Subscription New'
  },
  {
    id: '12',
    sku: 'L1L01-601151-A392',
    description: 'AutoCAD Perpetual License Commercial',
    contractTerm: '2 Year',
    itemGroup: 'AutoCAD',
    unitPrice: 15420.00,
    businessSegment: 'AEC',
    productLineDescription: 'Industry-leading design and documentation software',
    seatTypeId: 'License',
    skuTypeId: 'License'
  },
  {
    id: '13',
    sku: 'M2M01-701151-A392',
    description: 'AutoCAD Multi-User to Single-User Migration',
    contractTerm: 'Annual',
    itemGroup: 'AutoCAD',
    unitPrice: 1250.00,
    businessSegment: 'AEC',
    productLineDescription: 'Migration service from multi-user to single-user license',
    seatTypeId: 'M2S Renewal',
    skuTypeId: 'M2S Renewal'
  },
  {
    id: '14',
    sku: 'MP101-801151-A392',
    description: 'AutoCAD Maintenance Plan Annual Renewal',
    contractTerm: 'Annual',
    itemGroup: 'AutoCAD',
    unitPrice: 895.00,
    businessSegment: 'AEC',
    productLineDescription: 'Annual maintenance and support plan',
    seatTypeId: 'Maintenance Plan Renewal',
    skuTypeId: 'Maintenance Plan Renewal'
  },
  {
    id: '15',
    sku: 'MK101-901151-U001',
    description: 'AutoCAD Installation Media Kit USB',
    contractTerm: 'Monthly',
    itemGroup: 'AutoCAD',
    unitPrice: 125.00,
    businessSegment: 'AEC',
    productLineDescription: 'Physical installation media on USB drive',
    seatTypeId: 'Media Kit',
    skuTypeId: 'Media Kit'
  },
  {
    id: '16',
    sku: 'S2S01-771151-A392',
    description: 'Revit Standalone to Subscription Migration',
    contractTerm: '3-Year',
    itemGroup: 'Revit',
    unitPrice: 3650.00,
    businessSegment: 'AEC',
    productLineDescription: 'Migration service from standalone to subscription model',
    seatTypeId: 'S2S',
    skuTypeId: 'S2S'
  },
  {
    id: '17',
    sku: 'SV101-881151-H001',
    description: 'AutoCAD Implementation and Training Services',
    contractTerm: 'Annual',
    itemGroup: 'Professional Services',
    unitPrice: 4500.00,
    businessSegment: 'Services',
    productLineDescription: 'Professional implementation and training services',
    seatTypeId: 'Services',
    skuTypeId: 'Services'
  },
  {
    id: '18',
    sku: 'SLA01-991151-A001',
    description: 'AutoCAD License Activation Service',
    contractTerm: 'Monthly',
    itemGroup: 'Services',
    unitPrice: 250.00,
    businessSegment: 'Services',
    productLineDescription: 'Professional license activation and setup service',
    seatTypeId: 'Services License Activation',
    skuTypeId: 'Services License Activation'
  },
  {
    id: '19',
    sku: 'HW101-111151-D001',
    description: 'Workstation Graphics Card - NVIDIA RTX A4000',
    contractTerm: '2 Year',
    itemGroup: 'Hardware',
    unitPrice: 12500.00,
    businessSegment: 'Hardware',
    productLineDescription: 'Professional graphics card for CAD workstations',
    seatTypeId: 'Hardware',
    skuTypeId: 'Hardware'
  },
  {
    id: '20',
    sku: 'HW102-121151-D001',
    description: 'CAD Workstation Bundle - Intel i9 32GB RAM',
    contractTerm: '3-Year',
    itemGroup: 'Hardware',
    unitPrice: 35000.00,
    businessSegment: 'Hardware',
    productLineDescription: 'Complete workstation bundle for professional CAD work',
    seatTypeId: 'Hardware',
    skuTypeId: 'Hardware'
  }
];